export default {
  title: 'light',
  colors: {
    primary: '#3757a1',
    secondary: '#355db9',
    background: '#fff',
    text: '#222',
  },
};
